import $ from 'jquery'

export default class moveFirstHeadlineToStickyHeader {
    constructor(element) {
        this.$element = $(element)
        this.$firstHeadline = this.$element.find('h1, h2, h3, h4, h5, h6').eq(0)
        this.$header = $('.sticky-top').eq(0)

        this.isPageZero = Number(this.$element.data('page-number')) === 0
        console.log(this.isPageZero)

        this.moveHeadlineToHeader()

    }

    moveHeadlineToHeader() {
        if (this.$firstHeadline.parents('.ignoreStickyHeadline').length > 0) return

        const $wrappedElement = this.wrapElementInCockpitLayout(this.$firstHeadline)
        $wrappedElement.appendTo(this.$header)
    }

    wrapElementInCockpitLayout($element) {
        return $('<div>', {class: 'testkitPageContent bg-white'})
            .append(
                $('<div>', {class: 'cockpitLayout'})
                    .append(
                        $('<div>', {class: 'rowContainer'})
                            .append(
                                $('<div>', {class: 'overflow-hidden container-sm'})
                                    .append(
                                        $('<div>', {class: 'row'})
                                            .append(
                                                $('<div>', {class: 'col col-12 col-md-12 p-0'})
                                                    .append(
                                                        $('<div>', {class: `rowColContent px-3 pb-3 pt-${this.isPageZero ? '5' : '3'}`})
                                                            .append($element)
                                                    )
                                            )
                                    )
                            )
                    )
            )
    }

    destroy() {

    }
}
